export enum CompanyFilterEvents {
  VALUES_UPDATED = 'valuesUpdated',
  COMPANIES_CHANGE = 'companiesChange',
}

export const MAX_COMPANY_LIMIT = 25;
